import { Image3D, Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	max-width: 560px;
	display: flex;
	flex-flow: column;
	gap: ${({ theme }) => theme.spacings.xlarge};
	padding: ${({ theme }) =>
		`${theme.spacings.small} ${theme.spacings.xlarge} ${theme.spacings.xlarge} ${theme.spacings.xlarge}`};

	${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
		margin-bottom: ${({ theme }) => theme.spacings.xxlarge};
	}
`;

export const HeaderContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: ${({ theme }) => theme.spacings.large};
`;

export const BodyContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
`;

export const ImageContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const StyledImage = styled(Image3D)`
	width: 100%;
`;
export const StepText = styled(Text)`
	color: ${({ theme }) => theme.colors.text.main.enabled};
	text-align: center;
`;
export const Highlighted = styled.span`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
`;
export const Title = styled(Text)`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
	text-align: center;
`;
export const TextContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.medium};
	${({ theme }) => theme.fonts.text.text3}
`;
export const TitleContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.xxsmall};
`;
export const StepsNavigation = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacings.xsmall};
	justify-content: space-between;
	align-items: center;
`;
export const StepBallWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${({ theme }) => theme.sizing.medium};
	height: ${({ theme }) => theme.sizing.medium};

	cursor: pointer;
`;
export const StepBall = styled.div<{ $active?: boolean }>`
	height: ${({ theme }) => theme.sizing.xxxsmall};
	width: ${({ theme }) => theme.sizing.xxxsmall};
	border-radius: 50%;
	background-color: ${({ $active, theme }) =>
		$active ? theme.colors.backgrounds.brand.enabled : theme.colors.borders.main.divider};
	transition: background-color 0.2s ease-in-out;
`;

export const TooltipWrapper = styled.div`
	display: inline-block;
	margin-left: ${({ theme }) => theme.spacings.xxxsmall};
`;
